// import './plugins/file-manager'
import '../modules/tinymce'
import './plugins/material-icons'
import './plugins/tinymce-iconfonts'

const plugins = [
  'advlist autolink lists link image charmap hr anchor pagebreak preview searchreplace wordcount visualblocks',
  'visualchars code fullscreen insertdatetime media nonbreaking save table contextmenu directionality',
  'template paste textcolor colorpicker textpattern imagetools toc materialicon iconfonts'
]
const style_formats = [
  {
    title: 'Containers', items: [
      {title: 'Section', block: 'section', wrapper: true, merge_siblings: false},
      {title: 'Article', block: 'article', wrapper: true, merge_siblings: false},
      {title: 'Blockquote', block: 'blockquote', wrapper: true},
      {title: 'HGroup', block: 'hgroup', wrapper: true},
      {title: 'Aside', block: 'aside', wrapper: true},
      {title: 'Figure', block: 'figure', wrapper: true}
    ]
  },
  {
    title: 'Cores', items: [
      {title: 'Cor primária', inline: 'span', styles: {color: '#616161'}},
      {title: 'Cor secundária', inline: 'span', styles: {color: '#ff9800'}},
    ]
  }
]
const formats = {
  h1: {block: 'h1', classes: 'font-bold text-3xl lg:text-4xl text-focus-blue-dark'},
  h2: {block: 'h2', classes: 'font-bold text-2xl lg:text-3xl text-focus-blue-dark'},
  h3: {block: 'h3', classes: 'font-bold text-1xl lg:text-2xl text-focus-blue-dark'},
  h4: {block: 'h4', classes: 'font-bold text-1xl lg:text-1xl text-focus-blue-dark'},
  h5: {block: 'h5', classes: 'font-bold text-1xl lg:text-1xl text-focus-blue-dark'}
}
const templates = [
  {
    title: "Descrição de produto",
    description: "Modulo para descrição dos produtos",
    content: `
        <h2 class="font-bold text-3xl lg:text-4xl text-focus-blue-dark mt-2">Sobre a pós-graduação XXXX</h2>
        <br/>
        <h2 class="font-bold text-3xl lg:text-4xl text-focus-blue-dark mt-2">Para quem é este curso</h2>
        <br/>
        <h2 class="font-bold text-3xl lg:text-4xl text-focus-blue-dark mt-2">O que você vai aprender</h2>
        <br/>
      `
  },
  {
    title: "Caixa de texto abre/fecha",
    description: "Um elemento no formato accordion, util para seções em que se deve exibir/esconder conteúdos",
    content: `
      <div class="bg-gray-175 mb-3 accordion">
        <div class="flex justify-between items-center text-lg p-4 rounded-t border border-gray-300">
          <div>
            <p>
              <b class="font-semibold mr-3 accordion-key">
                1.
              </b>
              O que é Lorem Ipsum?
            </p>
          </div>
          <div class="cursor-pointer">
            <i class="fas fa-minus text-focus-blue-light accordion-button"><!-- icon --></i>
          </div>
        </div>
        <div class="accordion-body bg-white px-9 py-4 rounded-b border-r border-l border-b border-gray-300 block">
          <p class="leading-loose text-justify">
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lor
          </p>
        </div>
      </div>
      <p></p>
    `
  }
]

export default {
  selector: '.tinymce',
  branding: false,
  height: 200,
  language: 'pt_BR',
  language_url: '/assets/admin/js/tinymce/langs/pt_BR.js',
  skin_url: '/assets/admin/js/tinymce/skins/lightgray',
  browser_spellcheck: true,
  element_format: 'html',
  fix_list_elements: true,
  relative_urls: false,
  path_absolute : "/",
  remove_script_host: false,
  plugins,
  toolbar1: 'undo redo | fontsizeselect styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media | forecolor backcolor emoticons | preview  | button materialicon',
  content_css: [
    '/assets/admin/css/tiny/tiny.css',
    '/assets/admin/css/ecommerce.css',
  ],
  fontsize_formats: "10pt 12pt 14pt 18pt 24pt 36pt 50pt 60pt 70pt 80pt 90pt",
  style_formats_merge: true,
  style_formats,
  formats,
  templates,
  extended_valid_elements: 'i[class]',
  visualblocks_default_state: true,
  end_container_on_empty_block: true,
  setup: editor => {
    editor.on('blur', () => {
      // tinymce.save()
    })

    editor.addButton('button', {
      type: 'listbox',
      text: 'Botão',
      icon: false,
      tooltip: 'Inserir botão',
      onselect: function () {
        editor.insertContent(this.value())
      },
      values: [
        {text: 'Botão', value: '<a href="#" class="button lighten">Botão de ação</a>'},
        {text: 'Botão pequeno', value: '<a href="#" class="button button-small lighten">Botão de ação</a>'},
        {text: 'Botão grande', value: '<a href="#" class="button button-large lighten">Botão de ação</a>'},
        {text: 'Botão em bloco', value: '<a href="#" class="button button-block lighten">Botão de ação</a>'}
      ],
      onPostRender: function () {
        this.value('<a href="#" class="button lighten">Botão de ação</a>');
      }
    })
  },
  file_browser_callback : function(field_name, url, type, win) {
    var x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
    var y = window.innerHeight|| document.documentElement.clientHeight|| document.getElementsByTagName('body')[0].clientHeight;

    var cmsURL = "/admin/file-manager" + '?field_name=' + field_name;
    if (type == 'image') {
      cmsURL = cmsURL + "&type=Images";
    } else {
      cmsURL = cmsURL + "&type=Files";
    }

    tinymce.activeEditor.windowManager.open({
      file : cmsURL,
      title : 'Filemanager',
      width : x * 0.8,
      height : y * 0.8,
      resizable : "yes",
      close_previous : "no"
    })
  }
}
